var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height}},[_c('use',{attrs:{"xlink:href":((require("@/assets/svg/symbol/svg/sprite.symbol.svg")) + "#" + _vm.name)}})])}
var staticRenderFns = []

export { render, staticRenderFns }